import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'seo-banner_sign_up_to_shop_cta-click';

/**
 * Used to track CTA button click for logged-out brands counter banner that will be added in a variation (Desktop only) for an ABC experiment.
 * @deprecated by Devansh Bhardwaj on January 30, 2024
 */
export function trackSeoBannerSignUpToShopCtaClick(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
  });
}
